import React from 'react';
import { InputText } from "primereact/inputtext";
import "./input.scss";

export function Input(props) {
    const [type, setType] = React.useState(props.type);

    return (
        <div className={`p-inputgroup ${props.parentClass}`}>
            {
                props.icon &&
                <span className="p-inputgroup-addon">
                    <i className={props.icon}></i>
                </span>
            }
            <InputText
                id={props.id}
                value={props.value}
                type={type}
                name={props.name}
                onChange={props.onChange}
                placeholder={props.placeholder}
                className={`custom-input ${props.className}`}
                onFocus={props.onFocus}
                required={props.required}
                onBlur={props.onBlur}
                disabled={props.disabled}
                style={{ width: "100%", height: props.height }}
            />
            {
                props.rightSide && <span className="p-inputgroup-addon">
                    {props.rightSide}
                </span>
            }
            {
                props.type === "password" && <span className="p-inputgroup-addon span-mrg-icon-p">
                    <i className={type === 'text' ? "pi pi-eye" : "pi pi-eye-slash"}
                        onClick={() => {
                            setType(type === 'text' ? 'password' : 'text')
                        }}></i>
                </span>
            }
        </div>
    );
}